import { TRootState } from "../@types"

export const selectModalConfigurationCashback = ( state: TRootState ) =>state.configurationCashback.configurationCashbackModalIsOpen

export const selectIsUpdateConfigurationCashback = ( state: TRootState ) =>state.configurationCashback.isUpdateConfigurationCashback

export const selectConfigurationCashbackForUpdate = ( state: TRootState ) =>state.configurationCashback.configurationCashbackForUpdate

export const selectConfigurationCashbackRefreshTable =  ( state: TRootState ) =>state.configurationCashback.refreshTableConfigurationCashback
